import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Link from 'components/atoms/Link/Link';
import Heading from 'components/atoms/Heading/Heading';

const DefaultList = css`
	ul,
	ol {
		list-style-position: inside;
		padding-left: 0;
		margin-bottom: 0;

		li {
			border-bottom: 1px solid ${({ theme }) => theme.grey200};
			font-size: 0.95rem;
			padding: 0.5rem;

			&:last-child {
				border-bottom: none;
			}
		}
	}
`;

const StyledContent = styled.div``;

const CardWrapper = styled.div`
	background-color: ${({ theme }) => theme.grey100};
	margin-bottom: 1rem;
	padding: 0.75rem;

	${Heading} {
		display: block;
		padding: 0;
		font-weight: ${({ theme }) => theme.bold};
		line-height: 1.15;

		@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
			font-size: 1.25rem;
		}
	}

	${({ featured }) =>
		featured &&
		css`
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
			padding: 0;

			@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
				margin: 1rem;
				padding: 1rem;

				${StyledContent} {
					margin: 0 0.5rem;
				}
			}

			${Heading} {
				padding: 0.5rem 0.3rem 0.4rem 0.3rem;
				@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
					margin-left: -2rem;
				}
			}
		`}

	${({ unorderedList }) =>
		unorderedList &&
		css`
			${DefaultList}
			ul {
				list-style: none;
			}
		`}

	${({ orderedList }) =>
		orderedList &&
		css`
			${DefaultList}
			ol {
				margin-bottom: 0;
			}
		`}

	${({ featuredTitle }) =>
		featuredTitle &&
		css`
			${Heading} {
				background-color: ${({ theme }) => theme.info};
			}
		`}
`;

const CardClassic = ({ title, link, children, featured, featuredTitle, unorderedList, orderedList, more }) => (
	<CardWrapper
		unorderedList={unorderedList ? 1 : undefined}
		orderedList={orderedList ? 1 : undefined}
		featuredTitle={featuredTitle ? 1 : undefined}
		featured={featured ? 1 : undefined}
	>
		{link ? (
			<Link as={RouterLink} to={link}>
				<Heading featured={featured ? 1 : undefined}>{title}</Heading>
			</Link>
		) : (
			<Heading featured={featured ? 1 : undefined}>{title}</Heading>
		)}
		<StyledContent>
			{children}
			{link && more && (
				<Link as={RouterLink} to={link} featured={1} more={1}>
					Zobacz więcej...
				</Link>
			)}
		</StyledContent>
	</CardWrapper>
);

CardClassic.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	unorderedList: PropTypes.bool,
	orderedList: PropTypes.bool,
	featured: PropTypes.bool,
	featuredTitle: PropTypes.bool,
	more: PropTypes.bool,
	link: PropTypes.string,
};

CardClassic.defaultProps = {
	unorderedList: false,
	orderedList: false,
	featured: false,
	featuredTitle: false,
	more: false,
	link: '',
};

export default CardClassic;
